<template>
  <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
    <path d="M30,13.4c0-1.3-1-2.4-2.3-2.4H25V2H7v9H4.3C3,11,2,12.1,2,13.4V26h5v4h18v-4h5V13.4z M9,4h14v7H9V4z M23,28H9v-6h14V28z M28,24h-3v-4H7v4H4V13.4C4,13.2,4.1,13,4.3,13H7h18h2.7c0.2,0,0.3,0.2,0.3,0.4V24z" />
  </svg>
</template>

<script>
export default {
  name: 'PrintIcon'
}
</script>

<style scoped>

</style>
